import { get, post, put } from '@/common/ajax'

const login = (params) => post('sessions', params)

const getHouses = () => get('building_names')
const getAdvertisementTargetables = () => get('advertisement_targetables')

const getHouseDetail = (id) => get(`buildings/${id}/detail`)
const updateHouseDetail = (id, params) => put(`/buildings/${id}/detail`, params)

const getHouseNames = (id) => get(`/buildings/${id}/house_names`)

const getImgs = (id, category) => get(`buildings/${id}/image`, {
    category
})
const updateImgs = (id, category, images) => post(`buildings/${id}/image`, {
    category,
    images
})

const getWxAccount = (id, category) => get(`buildings/${id}/weixin_account`)
const updateWxAccount = (id, params) => put(`buildings/${id}/weixin_account`, params)

const getStats = (query) => get('building_stats', query)

const getClients = (query) => get('building_clients', {
    ...query,
    per: 20
})

const getUserInfo = () => get('user')

const getQuestions = (data) => get('questions', data)

const postAnswer = (id, answer) => put(`questions/${id}`, { answer })

const getWipsOauth = () => get('wips_oauth_url')

const getBuildingStats = (building_id, params) => get('ad_daily_stats', {
    building_id,
    ...params
})

const getBuildingCompare = (building_ids, params) => get('ad_stats', {
    building_ids,
    ...params
})

export default {
    login,

    getHouses,

    getAdvertisementTargetables,

    getHouseDetail,
    updateHouseDetail,
    getHouseNames,

    getImgs,
    updateImgs,

    getWxAccount,
    updateWxAccount,

    getStats,
    getClients,

    getUserInfo,

    getQuestions,
    postAnswer,

    getWipsOauth,
    getBuildingStats,
    getBuildingCompare
}
